import { render, staticRenderFns } from "./CampusCard.vue?vue&type=template&id=0e2e429b&scoped=true&"
import script from "./CampusCard.vue?vue&type=script&lang=js&"
export * from "./CampusCard.vue?vue&type=script&lang=js&"
import style0 from "./CampusCard.vue?vue&type=style&index=0&id=0e2e429b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e429b",
  null
  
)

export default component.exports